import getValueOffPercent from 'lib/offer/getValueOffPercent'
import { isDisplayablePrice } from 'lib/offer/pricingVisibility'

function includeStaySurcharges(pricing: App.PricingWithValue, surcharge: number): App.PricingWithValue {
  const price = pricing.price + surcharge
  return {
    ...pricing,
    price,
    discountPercent: getValueOffPercent(pricing.value, price),
    // Calendar availability prices already total all requested rooms and nights.
    saleUnit: 'total',
  }
}

export default function getSelectedDateOfferPricing(rate?: App.OfferAvailableRate): {
  default?: App.PricingWithValue
  member?: App.PricingWithValue
} {
  if (!rate?.defaultPricing || !isDisplayablePrice(rate.defaultPricing.price)) return {}

  // Base pricing already includes property fees and taxes. Calendar returns the
  // assigned LERE surcharge and occupancy surcharge separately from this amount.
  const surcharge = (rate.surcharge ?? 0) + (rate.extraGuestSurcharge ?? 0)
  return {
    default: includeStaySurcharges(rate.defaultPricing, surcharge),
    member: rate.memberPricing && isDisplayablePrice(rate.memberPricing.price)
      ? includeStaySurcharges(rate.memberPricing, surcharge)
      : undefined,
  }
}
